




















































import { iWithdrawals, TicketParams } from '@/store/interfaces/tickets';
import { status } from '@/util/transformString/translationsDecorator';
import { dateTime } from '@/util/filters/index';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'WithdrawalsRefund',
  props: {
    ticket: {
      type: Object as PropType<Omit<TicketParams, 'ticketable'> & { ticketable: iWithdrawals }>,
      required: true,
    },
  },
  data() {
    return {
      status,
      dateTime,
    };
  },
  computed: {
    withdrawalsRefundStatus(): string {
      return status(this.ticket.status);
    },
    total(): string {
      return `$${this.ticket.ticketable.amount_cents / 100}`;
    },
  },
});
